/*
 * @Copyright (c): Knowdee All rights reserved.
 * @Description: Type your file description
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2023-09-12 16:23:56
 * @LastEditTime: 2023-11-30 15:17:47
 * @FilePath: /client-h5-v2/src/apis/dialog/chatpoc.ts
 */

import store from '@/store/index'
// console.log(JSON.stringify(store.getters['global/pageConfig']))

// socket url地址
const socketUrl = '' + 'wss://fuguan-fumaohui.knowdee.com' + '/websocket/?dialogId=session_bot'
// const socketUrl = 'ws://172.70.10.203:8282/fuguan/?dialogId=session_bot'

let socket:any = null

socket = new WebSocket(socketUrl)

// 处理 WebSocket 的事件
socket.onopen = () => {
  console.log('WebSocket 连接成功')
}

// 发送消息
export const sendMessageToSystem = (message:any) => {
  const data = { data: [message], dialogId: 'session_bot' }
  console.log('发送消息给中控：', JSON.stringify(data))
  socket.send(JSON.stringify(data))
}

// 接收消息
socket.onmessage = (event:any) => {
  const data = JSON.parse(event.data).data[0]
  console.log(data)
  // console.log(data)
  let textData = {}
  if (data.type === 'text') {
    textData = {
      id: '',
      dialogInfo: data.dialogInfo,
      payload: {
        content: data.content
      },
      templateType: 'text'
    }
  } else if (data.type === 'image') {
    textData = {
      id: '',
      dialogInfo: data.dialogInfo,
      payload: {
        fileUrl: data.content,
        fileName: data.title,
        fileSize: '',
        fileType: ''
      },
      templateType: 'AnswerImage'
    }
  }
  // 清除loading
  store.commit('dialog/CLEAR_LOADING')
  // 提交消息到对话窗口
  store.commit('dialog/SET_TALK_LIST', [textData])
}
